import { checkTokenExpiration } from '../utils/checkTokenExpiration';
import { getCurrentSession } from '../../lib/authentication'

import featureFlags from '../utils/featureFlags';

export const fetchClearance = value => {
    const { data, type, user, person } = value;
    return Promise.all([checkTokenExpiration(user), getCurrentSession()])
        .then(results => {
            const { projectAddress, insuredAddress, primaryInsuredName } = data;
            const params = {
                'insured-name': primaryInsuredName.trim(),
                'insured-street-address': insuredAddress.primaryInsuredAddress
                    .replace('#', '')
                    .trim(),
                'insured-city': insuredAddress.primaryInsuredCity.trim(),
                'insured-state': insuredAddress.primaryInsuredState.trim(),
                'insured-zip': insuredAddress.primaryInsuredZipcode.trim(),
                'project-street-address': projectAddress.projectAddress.replace('#', '').trim(),
                'project-city': projectAddress.projectCity.trim(),
                'project-state': projectAddress.projectState.trim(),
                'project-zip': projectAddress.projectZipcode.trim(),
                'user-id': user.id,
                'brokerage-id': person.brokerId,
                product: type.toUpperCase(),
                'ref-id': ''
            };
            const [expirationToken, currentSession] = results;
            const { accessToken } = currentSession

            return apigClient.v1clearanceGet(
                params,
                {},
                {
                    headers: {
                        Authorization: accessToken
                    }
                }
            );
        })
        .catch(e => e);
};
